import { render, staticRenderFns } from "./ReceiverResponseRegistration.vue?vue&type=template&id=3b78cd30&scoped=true&"
import script from "./ReceiverResponseRegistration.vue?vue&type=script&lang=js&"
export * from "./ReceiverResponseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverResponseRegistration.vue?vue&type=style&index=0&id=3b78cd30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78cd30",
  null
  
)

export default component.exports